import React, { ReactElement } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { featureConfig } from 'modules/common';
import { useTranslation } from 'modules/i18n';
import { PlusIcon } from 'modules/icons';

import { faqData } from './faqData';
import { TokenExplorerLink } from './TokenExplorerLink';
import { translation } from './translation';

export function Faq(): ReactElement | null {
  const { classes } = useStyles();
  const { t, keys } = useTranslation(translation);

  if (!featureConfig.isFaqEnabled) return null;

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t(keys.faq)}</div>

      <div>
        {faqData.map(({ id, answer, question }) => (
          <Accordion key={id}>
            <AccordionSummary expandIcon={<PlusIcon />}>
              {question}
            </AccordionSummary>

            <AccordionDetails>
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: answer }}
              />

              {id === 2 && <TokenExplorerLink />}
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
}

const useStyles = makeStyles()(theme => ({
  root: {
    position: 'relative',
    gap: theme.spacing(2),
    borderRadius: 12,
    padding: theme.spacing(6),
    background: `linear-gradient(110.01deg, ${theme.palette.background.default} 8.7%, ${theme.palette.primary.contrastText} 40.24%)`,

    '&:before': {
      display: 'block',
      content: '""',
      position: 'absolute',
      inset: '0',
      borderRadius: 12,
      padding: theme.spacing(0.5),
      background: `linear-gradient(119.4deg, ${theme.palette.background.default} 0.86%, ${theme.palette.background.default} 21.93%)`,
      mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
      maskComposite: 'exclude',
    },

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
    },
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: 24,
    lineHeight: '29px',
    marginBottom: theme.spacing(6),
  },
}));
